import { useState, useEffect } from "react";

const apiUrl = process.env.REACT_APP_API_URL;

export default function AnnualLeave() {
  const [userName, setUserName] = useState("");
  const [requests, setRequests] = useState([]);
  const [error, setError] = useState("");

  const [form, setForm] = useState({
    type: "Annual Leave",
    name: userName,
    startDate: "",
    endDate: "",
    dayDate: "",
    dayType: "",
    reason: "",
  });

  useEffect(() => {
    const token = localStorage.getItem("token");
    const username = localStorage.getItem("user");
    const role = localStorage.getItem("role");

    if (username) {
      setUserName(username.charAt(0).toUpperCase() + username.slice(1));
    }

    // Include token in request headers
    fetch(`${apiUrl}/requests`, {
      headers: {
        "Authorization": `Bearer ${token}`,
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error("Failed to fetch requests");
        return res.json();
      })
      .then((data) => {
        // If user is admin, show all requests
        if (role === "Admin" && username === "yeabkal") {
          setRequests(data);
        } else {

          // Filter only this user's requests
          const userRequests = data.filter(
            (req) => req.name.toLowerCase() === username.toLowerCase()
          );
          setRequests(userRequests);
        }
      })
      .catch((err) => console.error(err));
  }, []);


  useEffect(() => {
    if (userName) {
      setForm((prev) => ({ ...prev, name: userName }));
    }
  }, [userName]);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const userId = localStorage.getItem("token");

    if (!userName) {
      setError("Name is required.");
      return;
    }

    fetch(`${apiUrl}/requests`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${userId}`,
      },
      body: JSON.stringify({ ...form, name: userName }),
    })
      .then((res) => res.json())
      .then((newReq) => {
        setRequests([...requests, newReq]);
        setForm({
          type: "Annual Leave",
          name: userName,
          startDate: "",
          endDate: "",
          dayDate: "",
          dayType: "",
          reason: "",
        });
      });
  };

  const handleStatusChange = (id, status) => {
    fetch(`${apiUrl}/requests/${id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ status }),
    }).then(() => {
      setRequests((prev) =>
        prev.map((r) => (r.id === id ? { ...r, status } : r))
      );
    });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "-";
    return new Date(dateStr).toLocaleDateString("en-US", {
      year: "numeric",
      month: "short",
      day: "numeric",
    });
  };

  return (
    <div className="min-h-screen flex flex-col items-center p-6  mt-20">
      <div className="w-full max-w-md bg-white shadow-lg rounded-2xl p-6">
        <form onSubmit={handleSubmit} className="space-y-4">
          <h2 className="text-xl font-bold mb-4">Leave / Day-Off Request</h2>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <select
            name="type"
            value={form.type}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
          >
            <option value="Annual Leave">Annual Leave</option>
            <option value="Day Off">Day Off</option>
          </select>

          <input
            type="text"
            name="name"
            placeholder={userName || "Your Name"}
            value={userName}
            onChange={handleChange}
            className="w-full p-2 border rounded-lg"
            required
          />

          {form.type === "Annual Leave" && (
            <>
              <div className="grid grid-cols-2 gap-4">
                <input
                  type="date"
                  name="startDate"
                  value={form.startDate}
                  onChange={handleChange}
                  className="p-2 border rounded-lg"
                />
                <input
                  type="date"
                  name="endDate"
                  value={form.endDate}
                  onChange={handleChange}
                  className="p-2 border rounded-lg"
                />
              </div>

              <textarea
                name="reason"
                placeholder="Reason (optional)"
                value={form.reason}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                rows="3"
              />
            </>
          )}

          {form.type === "Day Off" && (
            <>
              <input
                type="date"
                name="dayDate"
                value={form.dayDate}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
              />

              <select
                name="dayType"
                value={form.dayType}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
              >
                <option value="">Select Type</option>
                <option value="Normal">Normal (More than 1 day before)</option>
                <option value="Emergency">Emergency</option>
              </select>

              <textarea
                name="reason"
                placeholder="Reason (required for emergency)"
                value={form.reason}
                onChange={handleChange}
                className="w-full p-2 border rounded-lg"
                rows="3"
              />
            </>
          )}

          <button
            type="submit"
            className="w-full bg-blue-600 text-white p-2 rounded-xl hover:bg-blue-700"
          >
            Submit Request
          </button>
        </form>
      </div>

      {requests.length > 0 && (
        <div className="w-full max-w-3xl bg-white shadow-md rounded-2xl p-4">
          <h3 className="text-lg font-semibold mb-2">Submitted Requests</h3>
          <table className="w-full text-sm border">
            <thead>
              <tr className="bg-gray-200">
                <th className="border p-2">Name</th>
                <th className="border p-2">Type</th>
                <th className="border p-2">Dates</th>
                <th className="border p-2">Reason</th>
                <th className="border p-2">Status</th>
                {userName === "Yeabkal" && (
                  <th className="border p-2">Action</th>
                )}
              </tr>
            </thead>
            <tbody>
              {requests.map((req) => (
                <tr key={req.id} className="text-center">
                  <td className="border p-2">{req.name}</td>
                  <td className="border p-2">{req.type}</td>
                  <td className="border p-2">
                    {req.type === "Annual Leave"
                      ? `${formatDate(req.startDate)} → ${formatDate(
                        req.endDate
                      )}`
                      : formatDate(req.dayDate)}
                  </td>

                  <td className="border p-2">{req.reason || "-"}</td>
                  <td
                    className={`border p-2 font-semibold
                  ${req.status === "Rejected" ? "bg-red-500 text-white" : ""}
                  ${req.status === "Approved" ? "bg-green-500 text-white" : ""}
                  `}
                  >
                    {req.status}
                  </td>
                  {userName === "Yeabkal" && (
                    <td className="border p-2 space-x-2">
                      <button
                        onClick={() => handleStatusChange(req.id, "Approved")}
                        className="bg-green-500 text-white px-2 py-1 rounded hover:bg-green-600"
                      >
                        Approve
                      </button>
                      <button
                        onClick={() => handleStatusChange(req.id, "Rejected")}
                        className="bg-red-500 text-white px-2 py-1 rounded hover:bg-red-600"
                      >
                        Reject
                      </button>
                    </td>
                  )}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}
